import { Directive } from 'vue'
import { addClickOutside, removeClickOutside } from '@/utils/clickOutside'

const clickOutside: Directive<HTMLElement, (e: MouseEvent) => any> = {
  mounted(el, binding) {
    addClickOutside({
      el: el,
      onClickOutside: binding.value,
    })
  },
  beforeUnmount(el, binding) {
    removeClickOutside({ el, onClickOutside: binding.value })
  },
}

export default {
  name: 'clickOutside',
  definition: clickOutside,
}
